export const LoadingModal = () => {
  return <div
    // style={{ width: "calc(100% - 24rem)" }}
    className="fixed top-0 right-0 w-full h-screen grid place-items-center z-[10000]"
  >
    <div className="w-24 h-24 border-[8px] border-t-primary rounded-full relative animate-spin mb-20" />
  </div>
}